import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/materialsEnabled`;

export const ROUTE: RouteDefinition = `${baseRoute}/materialsEnabled`;

export const URL = (): RouteDefinition => `${baseRoute}/materialsEnabled`;
